import gql from 'graphql-tag';

const instiutionYearsGql = gql`
  query ($instId: String!) {
    institutions(instID: $instId) {
      live_date
    }
  }
`;
export default instiutionYearsGql;
